var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_vm._m(0),_c('main',{ref:"main"},[_c('TaskList')],1),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("Lista de tarefas")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',[_vm._v("Desenvolvido por ")]),_c('a',{attrs:{"href":"https://www.linkedin.com/in/alexandre-fb/","target":"_blank"}},[_vm._v("Alexandre Bisognin")])])
}]

export { render, staticRenderFns }